import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import firebase from '../../firebase';
import logger from '../../services/logger';


export function withLoginHandler(WrappedComponent) {
    return class extends Component {
        state = {
            isLoading: false,
            isLoginSuccess: null,
            loginFailMessage: null,
        };

        loginUser = async (email, password) => {
            this.setState({ isLoading: true, isLoginFail: false });

            try {
                await firebase.auth().signInWithEmailAndPassword(email, password);

                this.setState({ isLoginSuccess: true });
            } catch (e) {
                this.setState({
                    isLoading: false,
                    loginFailMessage: 'You have entered an invalid username or password',
                });

                logger.error(JSON.stringify(e));
            }
        }

        render() {
            const {
                isLoading,
                isLoginSuccess,
                loginFailMessage,
            } = this.state;

            if (isLoginSuccess) {
                return <Redirect to="/dashboard" />;
            }

            return (
                <WrappedComponent
                    isLoading={isLoading}
                    isLoginSuccess={isLoginSuccess}
                    loginFailMessage={loginFailMessage}
                    handleLoginUser={this.loginUser}
                    {...this.props}
                />
            );
        }
    }
}
